import Vue from 'vue';
import moment from 'moment';
import store from '@/store';

export default async function () {
  await Vue.$keycloak.updateToken(70)
    .then(() => {
      const momentoAtual = moment.unix(Vue.$keycloak.idTokenParsed.iat);
      const intervaloSessao = moment.unix(Vue.$keycloak.idTokenParsed.exp).diff(momentoAtual);
      const tempoSessao = moment.duration(intervaloSessao).asSeconds();
      const fimSessao = moment(momentoAtual).add(tempoSessao, 'seconds').add(30, 'minutes').format('LT');
      store.dispatch('app/setFimSessao', fimSessao).then(() => {
        store.dispatch(
          'app/setDataAtual',
          moment.unix(Vue.$keycloak.idTokenParsed.iat).format('YYYY-MM-DD'),
        );
      });
    })
    .catch(() => {
      store.dispatch('app/setLoginExpirado', true);
    });

  return Vue.$keycloak.token;
}
